import React, {
  ComponentProps,
} from 'react';
import {
  useFormContext,
} from 'react-hook-form';
import clsx from 'clsx';
import EditableNumberField from 'views/EMR/components/EditableNumberField';
import {
  AuthorizationFormValues,
  isPositiveWholeNumber,
} from 'views/EMR/components/Authorizations/formUtils';

type Props = Omit<ComponentProps<typeof EditableNumberField>, 'props'> & {
  props?: { className?: string };
};

export default function ApprovedUnitsField({ props, ...field }: Props) {
  const { formState: { errors } } = useFormContext<AuthorizationFormValues>();
  const hasError = Boolean(errors.allowances) && !isPositiveWholeNumber(field.value ?? undefined);

  return (
    <EditableNumberField
      {...field}
      props={{
        ...props,
        error: hasError,
        className: clsx(props?.className, { 'has-error !border-red-500': hasError }),
      }}
    />
  );
}
